module.exports = __webpack_public_path__ + "static/media/no_template.c7ebae80.svg";